// Используем при расчете размеров элементов, чтобы корректно выставить размеры карты
export const ELEMENTS_IDS = {
  filtersId: 'commercial-filters-frontend-wrapper',
  headerId: 'header-frontend',
  listingNodeId: 'commercial-listing',
  mapContainerNodeId: 'commercial-map-container',
  mapWrapperNodeId: 'commercial-map-wrapper',
} as const;
